import { Radio, RadioGroupProps as _RadioGroupProps } from 'antd'

import './RadioGroup.css'

type RadioGroupProps = _RadioGroupProps

const RadioGroup = ({ className, ...props }: RadioGroupProps) => {
  return (
    <Radio.Group
      className={`customRadioGroup ${className}`}
      {...props}
    />
  )
}

export default RadioGroup
